import { jsx as _jsx } from "react/jsx-runtime";
import DomPurify from "isomorphic-dompurify";
import { useTranslations } from "../../providers/useTranslations";
const { sanitize } = DomPurify;
export const TranslationHtmlWrapper = ({ text, htmlData, className = "" }) => {
    const { __ } = useTranslations();
    return (_jsx("span", { className: `${className}`, dangerouslySetInnerHTML: {
            __html: sanitize(__(text, htmlData), { ADD_ATTR: ["target"] }),
        } }));
};
//# sourceMappingURL=TranslationHtmlWrapper.js.map